/**
 * Datos de contacto por WhatsApp. Viven acá para que el número no quede
 * duplicado entre el botón flotante y los CTA de las landings.
 */

export const WHATSAPP_NUMEROS = {
  AR: "5491128357048",
  UY: "59892281806",
} as const;

/** Verde de marca de WhatsApp. */
export const WHATSAPP_VERDE = "#25D366";

export const MENSAJE_AYUDA_SEGURO =
  "¡Hola!, necesito ayuda para elegir mi seguro";

export const getWhatsappNumero = (pais?: string): string =>
  pais === "UY" ? WHATSAPP_NUMEROS.UY : WHATSAPP_NUMEROS.AR;

/** Link de WhatsApp con el mensaje precargado. */
export const getWhatsappUrl = (
  pais?: string,
  mensaje: string = MENSAJE_AYUDA_SEGURO
): string => {
  const numero = getWhatsappNumero(pais);
  return `https://api.whatsapp.com/send/?phone=${numero}&text=${encodeURIComponent(
    mensaje
  )}&type=phone_number&app_absent=0`;
};
